import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

const TipComponent = ({ value }) => {
  const { t } = useTranslation(["blog"]);
  const { text } = value || {};

  if (!text) {
    return null;
  }

  return (
    <div className='max-w-[680px] w-full mx-auto my-12' id='tip_component'>
      <div className='bg-[#241025] pt-4 pb-2 pl-4 pr-4 sm:!p-8 rounded-lg'>
        <div className='flex flex-row items-center justify-center'>
          <div className='w-[100%] lg:w-full'>
            <div className='flex items-center justify-center mb-3'>
              <svg width='32' height='32' viewBox='0 0 64 64' className='mb-1' xmlns='http://www.w3.org/2000/svg'>
                <path className='stroke-white fill-none stroke-[2.5]' strokeLinecap='round' strokeLinejoin='round' d='M29,45.17H35.4a2,2,0,0,1,2,2h0a2,2,0,0,1-2,2H29' />
                <circle cx='32' cy='52.86' r='1' className='stroke-white fill-none stroke-[2.5]' />
                <path className='stroke-white fill-none stroke-[2.5]' strokeLinecap='round' strokeLinejoin='round' d='M33.77,35.52a4.26,4.26,0,0,1,.14-2.69,12.83,12.83,0,0,1,1.62-2.4c1.51-2.12-5-1.76-5.75-1.64a5.53,5.53,0,0,0-.64.14c-1.45.42-.79,1.63-.13,2.47a5.56,5.56,0,0,1,1.5,2.46,4.27,4.27,0,0,1-1.95,4.08c-1.73,1.24-3.59.7-5-.77a9.84,9.84,0,0,1-2.43-6.84A10.85,10.85,0,1,1,32,41.17H29a2,2,0,0,0-2,2,2,2,0,0,0,2,2h6.42' />
                <line x1='16' x2='45' y1='14.41' className='stroke-white stroke-2' y2='17.98' />
                <line className='stroke-white stroke-2' x1='18' y1='14.3' x2='40' y2='12.89' />
              </svg>
              <p className='text-white text-[18px] font-bold text-center font-["Oxanium"] '>{t("tip", "Náš tip")}</p>
            </div>
            <div className='w-[100%] lg:w-full text-center'>
              <p className='text-white opacity-100 font-light font-rubik text-md md:text-base mb-4 sm:mx-0 xxxl:mx-4 cursor-default leading-0!important'>{text}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

TipComponent.propTypes = { value: PropTypes.shape({ text: PropTypes.string }) };
export default TipComponent;
